import { Button } from '@progress/kendo-react-buttons';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { documentManagerIcon } from '@progress/kendo-svg-icons';
import { useState } from 'react';
import { OrderServiceExceptionViewModel } from 'TypeGen/ServiceExceptions/order-service-exception-view-model';
import Documents from 'views/Documents/Documents';
import { DocumentType } from "TypeGen/Documents/document-type";

export const EscalationSOPCell = (props: GridCustomCellProps) => {
  const dataItem = props.dataItem as OrderServiceExceptionViewModel;
  const [showDocuments, setShowDocuments] = useState(false);
  return <td {...props.tdProps}>
    {showDocuments && <Documents
      IsWindow
      EntityType={0}
      EntityId={dataItem.AuthorizationCustomerID}
      EntityNumber="Authorization Company Escalation SOPs"
      DocumentType={DocumentType.EscalationStandardOperatingProcedure}
      CloseDocumentModal={(numberOfDocuments) => {
        setShowDocuments(false);
        dataItem.HasEscalationSOP = (numberOfDocuments > 0);
      }}
    />}
    <Button themeColor={dataItem.HasEscalationSOP ? "error" : undefined} svgIcon={documentManagerIcon} onClick={() => setShowDocuments(true)} />
  </td>
}